import React, { useState } from "react";
import "../styles/Photos.css";

// ✅ Import all your images
import photo1 from "../Assets/Images/1. pitha udsob 2.JPG";
import photo2 from "../Assets/Images/7. Footbal Celebration2 1-25.JPG";
import photo3 from "../Assets/Images/class2.JPG";
import photo4 from "../Assets/Images/class1.JPG";
import photo5 from "../Assets/Images/building1.jpg";
import photo6 from "../Assets/Images/bulding2.JPG";
import photo7 from "../Assets/Images/fire safty1.jpg";
import photo8 from "../Assets/Images/fire-safty2.jpg";
import photo9 from "../Assets/Images/work1.jpg";
import photo10 from "../Assets/Images/work2.jpg";
import photo11 from "../Assets/Images/work3.JPG";
import photo12 from "../Assets/Images/work4.jpg";
import photo13 from "../Assets/Images/work5.jpg";
import photo14 from "../Assets/Images/work6.jpg";
import photo15 from "../Assets/Images/work7.jpg";
import photo16 from "../Assets/Images/work8.jpg";
import photo17 from "../Assets/Images/work9.jpg";
import photo18 from "../Assets/Images/work10.jpg";
import photo19 from "../Assets/Images/car-training.jpg";

const photos = [
  { id: 1, src: photo1, title: "pitha udsob" },
  { id: 2, src: photo2, title: "Footbal Celebration" },
  { id: 3, src: photo3, title: "Class" },
  { id: 4, src: photo4, title: "Class" },
  { id: 5, src: photo5, title: "Building" },
  { id: 6, src: photo6, title: "Building" },
  { id: 7, src: photo7, title: "Fire safty" },
  { id: 8, src: photo8, title: "Fire safty" },
  { id: 9, src: photo9, title: "Work" },
  { id: 10, src: photo10, title: "Work" },
  { id: 11, src: photo11, title: "Work" },
  { id: 12, src: photo12, title: "Work" },
  { id: 13, src: photo13, title: "Work" },
  { id: 14, src: photo14, title: "Work" },
  { id: 15, src: photo15, title: "Work" },
  { id: 16, src: photo16, title: "Work" },
  { id: 17, src: photo17, title: "Work" },
  { id: 18, src: photo18, title: "Work" },
  { id: 19, src: photo19, title: "Training Car" },
];

export default function Photos() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="photos">
      <h2 className="photos-title">Photo Gallery</h2>
      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={photo.id}
            className="photo-card"
            onClick={() => openModal(index)}
            style={{ cursor: "pointer" }}
          >
            <img src={photo.src} alt={photo.title} className="photo-img" />
            <div className="photo-overlay">
              <h3>{photo.title}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Modal for Enlarged Photo */}
      {isModalOpen && (
        <div className="photo-modal">
          <button className="close-btn" onClick={closeModal}>✖</button>
          <button className="nav-btn left" onClick={goToPrevious}>◀</button>
          <img
            src={photos[currentIndex].src}
            alt={photos[currentIndex].title}
            className="modal-photo"
          />
          <button className="nav-btn right" onClick={goToNext}>▶</button>
        </div>
      )}
    </div>
  );
}
